module.exports = __webpack_public_path__ + "assets/images/project/head/Prateek_Kuhad.jpg?v=cf421965";